import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Blank = () => {
  return (
    <Box padding="s40">
      <Text weight="medium" size="300" color="grey600">
        {i18n.t('employees.no_employees_found')}
      </Text>
    </Box>
  )
}

export default Blank
